import axios from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { BASE_API_URL } from '../../utils/constants';
import { AppAuthorizeInforDistSXModalProps } from '../../components/general/AppAuthorizeInforDistSXModal';
import { myFirebaseAuth } from '../../firebase/config';

export const authorizeInforDistSXService = createAsyncThunk(
  'invoice/inforDistSX/authorizeInforDistSXService',
  async (
    {
      supplierId,
      integrationDetails,
    }: { supplierId: string; integrationDetails: AppAuthorizeInforDistSXModalProps },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      const response = await axios.post<any>(
        `${BASE_API_URL}/suppliers/${supplierId}/inforDistSX/authorize`,
        {
          integrationDetails,
        },
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const disconnectInforDistSXService = createAsyncThunk(
  'invoice/inforDistSX/disconnectInforDistSXService',
  async ({ supplierId }: { supplierId: string }) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      const response = await axios.get<any>(
        `${BASE_API_URL}/suppliers/${supplierId}/inforDistSX/disconnect`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return error;
    }
  }
);

export const getInforDistSXInvoicesService = createAsyncThunk(
  'invoice/inforDistSX/getInforDistSXInvoicesService',
  async (
    {
      supplierId,
      startAfter,
      itemsPerPage,
      invoiceType,
    }: {
      supplierId: string;
      startAfter?: string | null;
      itemsPerPage?: number;
      invoiceType?: string;
    },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();

      const queryParams = [];
      if (startAfter) {
        queryParams.push(`startAfter=${startAfter}`);
      }
      if (itemsPerPage) {
        queryParams.push(`itemsPerPage=${itemsPerPage}`);
      }
      if (invoiceType) {
        queryParams.push(`invoiceType=${invoiceType}`);
      }
      const response = await axios.get<any>(
        `${BASE_API_URL}/suppliers/${supplierId}/inforDistSX/invoice?${queryParams.join('&')}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const deleteInforDistSXSupplierInvoice = createAsyncThunk(
  'invoice/inforDistSX/deleteSupplierInvoice',
  async ({
    supplierId,
    invoiceId,
    invoiceType,
  }: {
    supplierId: string;
    invoiceId: string;
    invoiceType: string;
  }) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      const response = await axios.delete<any>(
        `${BASE_API_URL}/suppliers/${supplierId}/inforDistSX/invoice/${invoiceId}?invoiceType=${invoiceType}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return error;
    }
  }
);
